/* eslint-disable max-len */
import React from 'react';
import './CheckboxNew.scss';
import CheckIcon from './CheckIconNew';
// import Loading from '../Loading';
type Props = {
  id?: string;
  children?: any;
  name: string;
  onClick?: (arg?: any) => void;
  onChange?: (arg?: any) => void;
  value: boolean;
  loading?: boolean;
  backgroundColor?:string;
  iconColor?:string;
  height?:string;
  isLeftContent?:boolean;
  width?:string;
  inputClassName?:any;
  disabled?:boolean;
};
const CheckboxNew = ({
  id,
  children,
  name,
  onClick,
  onChange,
  value,
  loading,
  backgroundColor,
  iconColor,
  height,
  isLeftContent,
  width,
  inputClassName,
  disabled,
}: Props) => (
  <div className="checkbox-new" style={{ height, width }}>
    <input
      id={id}
      name={name}
      checked={value}
      onChange={!disabled && onChange}
      type="checkbox"
      disabled={disabled || loading}
      className={inputClassName}
    />
    <label onClick={() => (!disabled) && onClick && onClick()} htmlFor={id} style={{ width }}>
      {
        isLeftContent && (
        <div className="checkbox-left-content">
          {children}

        </div>
        )
      }

      {loading ? (
        <div />
      ) : (
        <div className="checkIcon" style={{ backgroundColor: disabled ? 'rgba(208, 208, 208, 1)' : backgroundColor, border: value ? 'rgba(18, 18, 18, 1)' : '', cursor: disabled ? 'not-allowed' : 'pointer' }}>
          <div className="checked flexed-center">
            <CheckIcon color={iconColor} />
          </div>
        </div>
      )}
      {!isLeftContent && <span>{children}</span>}

    </label>
  </div>
);

export default CheckboxNew;
